export const MY_PASSPORT_ID_TYPE_CD = 'M01005';

function asContactRecord(contact: unknown): Record<string, unknown> | null {
    if (!contact || typeof contact !== 'object') return null;
    return contact as Record<string, unknown>;
}

export function resolveContactIdTypeCd(contact: unknown): string {
    const record = asContactRecord(contact);
    if (!record) return '';
    return String(
        record.ID_TYPE_CD ?? record.idTypeCd ?? record.identificationType ?? '',
    )
        .trim()
        .toUpperCase();
}

export function isMyPassportIdType(contact: unknown): boolean {
    return resolveContactIdTypeCd(contact) === MY_PASSPORT_ID_TYPE_CD;
}